import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import {toastr} from 'react-redux-toastr';

import MissionForm from '../../Forms/MissionForm/MissionForm.jsx';
import Modal from '../../../../shared/components//Modals/Modal.jsx';
import SubmitButton from '../../Forms/MissionForm/SubmitButton.jsx';

import withCurrentUniverse from '../../../HOC/withCurrentUniverse.jsx';

import {
  defaultMissionTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/defaultMissionTemplate.js";
import {
  purchaseTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/purchaseTemplate.js";
import {
  humanResourceTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/humanResourceTemplate.js";
import {
  financeTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/financeTemplate.js";
import {
  engineeringTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/engineeringTemplate.js";
import PropTypes from "prop-types";

const universeTemplate = [
  {code: 'purchase', template: purchaseTemplate},
  {code: 'finance', template: financeTemplate},
  {code: 'hr', template: humanResourceTemplate},
  {code: 'engineering', template: engineeringTemplate},
]

class MissionModal extends Modal {

  static propTypes = {
    currentUniverse: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props);

    this.state = {
      universeTemplate: defaultMissionTemplate
    }
    this.close = () => this.props.closeModal(true);
  }
  onSubmitSuccess = () => {
    let action = 'créé';
    if (this.props.offset !== undefined) {
      action = 'modifié'
    }

    toastr.success('Le mandat a été ' + action + ' avec succès.');
    this.close()
  }

  componentDidUpdate() {
    if(!this.props || !this.props.currentUniverse || !this.props.currentUniverse.code ){
      return
    }
    const universeCode = this.props.currentUniverse.code
    const found = universeTemplate.find((universe) => universe.code === universeCode)
    if (!found) {return}
    this.setState({universeTemplate: found.template})
  }

  onSubmitModal = (values) => {
    values.locality = values?.locality?.[0]?.label ?? values?.locality ?? null;

    const experiences = this.props?.experiences?.length ? this.props.experiences : [];

    if (this.props.offset !== undefined) {
      experiences[this.props.offset] = values;
    } else {
      experiences.push(values);
    }

    if (this.props.onSubmit) {
      this.props.onSubmit({
        freelance: {experiences: experiences},
        silentMode: true,
      });
    }

    this.props.closeModal();
  };

  render() {
    if (!this.props.freelance) {
      return null;
    }
    const experience = (this.props.offset !== undefined && this.props.experiences[this.props.offset]) ?
      this.props.experiences[this.props.offset] : {};

    return (
      <BootstrapModal
        toggle={this.props.closeModal}
        isOpen={this.props.isOpen}
        className="mission-modal modal-lg"
        backdrop={'static'}
      >
        <ModalHeader toggle={this.props.closeModal}>Mandat</ModalHeader>
        <ModalBody>
          <MissionForm
            onSubmitSuccess={this.onSubmitSuccess}
            initialValues={{
              ...experience,
              description: (experience.description) ? experience.description : this.state.universeTemplate
            }}
            onSubmit={this.onSubmitModal}
            onClose={this.onClose}/>
          <div className="text-center">
            <SubmitButton className="btn btn-primary my-3">
              Enregistrer
            </SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default withCurrentUniverse(MissionModal);
